export default theme => ({
  root: {
    flexGrow: 1,
    background: '#000',
    paddingRight: 15,
    fontSize: 13,
    '& a': {
      display: 'inline-block',
      padding: '3px 0',
      color: ['#fff', 'important'],
    },
    '& a:visited': {
      color: '#fff',
    }
  }
});